import axios from 'axios';
import './axiosInterceptor';
export const PASARELA = process.env.VUE_APP_URLPASARELA;
export const Facturacion = {
    informacion_facturacion(params) {
        return  axios.get(PASARELA+"/administracion/cliente", {params})
    },
}
